//
//
//
//
//
//
//
//
//
//
//

import Header from "@/components/core/Header";
import Fotter from "@/components/core/Fotter";
import Menu from "@/components/core/Menu";
import Content from "@/components/core/Content";
import AustinHairlineRoman from "./assets/FONT-DEJUDOM/AustinHairline-Roman.otf";

export default {
  name: "App",
  components: {
    Header,
    Menu,
    Content,
    Fotter,
  },
  mounted() {
    this.$store.dispatch({ type: "restoreLogin" });
  },
};
